import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';import moment from 'moment';

export default [
  {
    name: 'code',
    label: i18n('entities.eventSchedule.fields.code'),
    schema: schemas.string(
      i18n('entities.eventSchedule.fields.code'),
      {
        "required": true,
        "max": 136
      },
    ),
  },
  {
    name: 'name',
    label: i18n('entities.eventSchedule.fields.name'),
    schema: schemas.string(
      i18n('entities.eventSchedule.fields.name'),
      {
        "required": true,
        "max": 128
      },
    ),
  },
  {
    name: 'eventFrom',
    label: i18n('entities.eventSchedule.fields.eventFrom'),
    schema: schemas.date(
      i18n('entities.eventSchedule.fields.eventFrom'),
      {},
    ),
   render: (value) => value && value instanceof Date ? moment(value).format('YYYY-MM-DD') : value,
  },
  {
    name: 'eventHour',
    label: i18n('entities.eventSchedule.fields.eventHour'),
    schema: schemas.string(
      i18n('entities.eventSchedule.fields.eventHour'),
      {
        "max": 8
      },
    ),
  },
  {
    name: 'contacts',
    label: i18n('entities.eventSchedule.fields.contacts'),
    schema: schemas.relationToMany(
      i18n('entities.eventSchedule.fields.contacts'),
      {
        "required": true
      },
    ),
  },
];